import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";

import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function Placeholder({ project }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.placeholder}>
      <p>{t("membersList.groupPlaceholder")}</p>
      <Button
        className={styles.button}
        press={() =>
          pushView({
            key: UseCases.addResourceGroup,
            data: {
              namespace: project.uuid,
              resourceType: "project",
            },
          })
        }
      >
        Ajouter
      </Button>
    </div>
  );
}

export { Placeholder };
